<template>
  <v-card height="810px">
    <v-container fluid>
      <v-row no-gutters>
        <v-col cols="6">
          <h2 class="title">
            {{ venue ? `TOP SUCURSAL` : "TOP GLOBAL" }} - Total de ordenes
            asignadas por mecánico.
          </h2>
        </v-col>
        <v-col cols="6">
          <h2 class="title text-right">
            {{ currentPage + 1 }} de {{ totalPages }}
          </h2>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-row justify="end" class="pa-0 ma-0">
        <v-col cols="12" sm="10" md="7" lg="7" class="pa-0 ma-0">
          <!--
          <v-overflow-btn
            append-icon="arrow_drop_down"
            class="combo active ma-0 pa-0"
            color="accent"
            v-model="filterBy"
            label="RANKING - MAYOR NÚMERO DE ORDENES CERRADAS A MENOR NÚMERO"
            height="25"
            @change="orderBy(filterBy)"
            :items="[
              {
                text:
                  'RANKING - MAYOR NÚMERO DE ORDENES CERRADAS A MENOR NÚMERO',
                value: 'closedDesc'
              },
              {
                text:
                  'RANKING - MENOR NÚMERO DE ORDENES CERRADAS A MAYOR NÚMERO',
                value: 'closedAsc'
              }
            ]"
          ></v-overflow-btn>
          -->
          <div class="filter font-weight-light">
            RANKING - MAYOR NÚMERO DE ORDENES CERRADAS A MENOR NÚMERO
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-simple-table height="730px">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">Ranking</th>
                  <th class="text-center">Colaborador</th>
                  <th></th>
                  <th class="text-center">Centro Operativo</th>
                  <th class="text-center">Ordenes Asignadas</th>
                  <th class="text-center">Cerradas</th>
                  <th class="text-center">Abiertas</th>
                  <th class="text-center">Tiempo Promedio</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(person, index) in peopleCurrentPage"
                  v-bind:key="person.id"
                  class="text-center"
                >
                  <td>{{ index + 1 + currentPage * 14 }}</td>
                  <td class="name">
                    {{
                      person.name ? splitName(person.name) : "" | lowerCaseName
                    }}
                  </td>
                  <td>
                    <v-avatar size="32">
                      <img :src="person.photo_url" alt="John" />
                    </v-avatar>
                  </td>
                  <td>{{ person.venue }}</td>
                  <td>{{ person.assigned_orders }}</td>
                  <td class="black--text pa-0">
                    {{ person.closed_orders }} -
                    {{
                      percentageClosed(
                        person.assigned_orders,
                        person.closed_orders
                      ) | oneDecimal
                    }}%
                  </td>
                  <td class="black--text pa-0">
                    {{ person.open_orders }} -
                    {{
                      percentageClosed(
                        person.assigned_orders,
                        person.open_orders
                      ) | oneDecimal
                    }}%
                  </td>
                  <td>
                    {{ person.time | oneDecimal
                    }}{{ person.time == 1 ? " HR" : " HRS" }}
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>
<script>
import { mapActions, mapState } from "vuex";
import { oneDecimal, lowerCaseName } from "@/filters";
export default {
  props: {
    venue: String,
    intervalChangeSeconds: Number
  },
  filters: {
    oneDecimal: oneDecimal,
    lowerCaseName: lowerCaseName
  },
  data() {
    return {
      filterBy: {
        text: "RANKING - MAYOR NÚMERO DE ORDENES CERRADAS A MENOR NÚMERO",
        value: "closedDesc"
      },
      currentPage: 0,
      peopleCurrentPage: [],
      totalPages: 0
    };
  },
  mounted() {
    if (this.venue) {
      this.getPeopleRanking(this.venue);
    } else {
      this.getPeopleRanking();
    }
    let vueInstance = this;
    setInterval(() => {
      if (vueInstance.currentPage < vueInstance.totalPages - 1)
        vueInstance.currentPage++;
      else vueInstance.currentPage = 0;
      this.updatePeoplePage();
    }, vueInstance.intervalChangeSeconds * 1000);
  },
  computed: {
    ...mapState("people", ["people", "peopleUpdated"]),
    venueMap() {
      let venue = "global";
      if (this.venue) venue = this.venue;
      return venue;
    }
  },
  methods: {
    ...mapActions("people", [
      "getPeopleRanking",
      "closedOrdersAsc",
      "closedOrdersDesc"
    ]),
    orderBy(filter) {
      switch (filter) {
        case "closedAsc":
          this.closedOrdersAsc();
          break;
        case "closedDesc":
          this.closedOrdersDesc();
          break;
      }
    },
    percentageClosed(asigned, closed) {
      return (closed / asigned) * 100;
    },
    percentageOpen(asigned, open) {
      return (open / asigned) * 100;
    },
    updatePeoplePage() {
      if (this.people[this.venueMap]) {
        this.peopleCurrentPage = this.people[this.venueMap].slice(
          this.currentPage * 14,
          this.currentPage * 14 + 14
        );
      } else this.peopleCurrentPage = [];
      if (this.people[this.venueMap]) {
        this.totalPages = Math.ceil(this.people[this.venueMap].length / 14); //people that fit in one page
      } else this.totalPages = 0;
    },
    splitName(name) {
      if (name.split("]").length > 0) {
        if (!name.split("]")[1]) {
          return name.split("]")[0];
        } else {
          return name.split("]")[1];
        }
      } else {
        return name;
      }
    }
  },
  watch: {
    venue: {
      handler: function(branch) {
        if (branch) {
          this.getPeopleRanking(branch);
        } else {
          this.getPeopleRanking();
        }
      },
      deep: true,
      immediate: true
    },
    peopleUpdated() {
      this.updatePeoplePage();
    }
  }
};
</script>
<style lang="css" scoped>
thead th {
  text-transform: uppercase;
  font-weight: 400;
  word-break: normal;
}
tbody td {
  color: #808080;
  font-size: 14px;
}
tr:nth-child(even) {
  background: #efefef 0% 0% no-repeat padding-box;
}
.title {
  font-weight: 400 !important;
  color: black;
  font-size: 16px !important;
}
.name {
  text-transform: capitalize;
}

.filter {
  text-align: right;
  font-size: 12px;
  letter-spacing: 0;
  color: #808080;
  opacity: 1;
}
</style>
